import { FC } from "react";
import { ErrorMessage, Field, Form } from "formik";

import { LabelLogin } from "@/shared/components/atoms/LabelLogin";
import { Input } from "@/shared/components/atoms/Input";
import { ButtonLogin } from "../atoms/ButtonLogin";
import { LinkLogin } from "../atoms/LinkLogin";

export type LogInFormProps = {
  onSubmit: () => void;
  isLoading: boolean;
  usernameLabelText: string;
  usernameAutoComplete: boolean;
  usernamePlaceholder: string;
  passwordLabelText: string;
  passwordAutoComplete: boolean;
  passwordPlaceholder: string;
  termsLabelText: string;
  forgotEvent: () => void;
  textForgot: string;
  problemEvent: () => void;
  textProlem: string;
  submitButtonText: string;
};

export const LogInForm: FC<LogInFormProps> = ({
  onSubmit,
  isLoading,
  usernameLabelText,
  usernameAutoComplete,
  usernamePlaceholder,
  passwordLabelText,
  passwordAutoComplete,
  passwordPlaceholder,
  termsLabelText,
  forgotEvent,
  textForgot,
  problemEvent,
  textProlem,
  submitButtonText,
}) => {
  return (
    <Form className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <LabelLogin
          texto={usernameLabelText}
          htmlFor="log-in-form-username-input"
        />
        <Field
          as={Input}
          id="log-in-form-username-input"
          name="email"
          type="text"
          placeholder={usernamePlaceholder}
          autoComplete={usernameAutoComplete}
        />
        <ErrorMessage name="email" component="small" className="text-red-500" />
      </div>

      <div className="flex flex-col gap-2">
        <LabelLogin
          texto={passwordLabelText}
          htmlFor="log-in-form-password-input"
        />
        <Field
          as={Input}
          id="log-in-form-password-input"
          name="password"
          type="text"
          placeholder={passwordPlaceholder}
          autoComplete={passwordAutoComplete}
        />
        <ErrorMessage
          name="password"
          component="small"
          className="text-red-500"
        />
      </div>

      <div className="mt-5 mb-7">
        <ButtonLogin
          primary
          text={submitButtonText}
          isLoading={isLoading}
          onClick={onSubmit}
          role="submit"
          type="submit"
          className="bg-customPurple hover:bg-customPurple/80"
        />
      </div>

      <div className="space-y-1">
        <div className="text-sm leading-6">
          <LinkLogin onClick={forgotEvent} texto={textForgot} />
        </div>

        <div className="text-sm leading-6">
          <LinkLogin onClick={problemEvent} texto={textProlem} />
        </div>
      </div>
    </Form>
  );
};
